import { Component, OnInit } from '@angular/core';
import { LeftMenu } from '../../shared/leftmenu/LeftMenu';
import { Router } from '@angular/router';
import { DataStorageService } from '../../shared/data-storage.service';
import * as Chart from 'chart.js';
import { NGXLogger } from 'ngx-logger';
import { DatePipe } from '@angular/common';
import { ViewBankDashboard, PaymentTxnsAmountInputForBoth, PaymentTxnsAmountOutputForBoth, PaymentSuccessFailureOutputForBoth, TopRecordsInput, TopRecordsOutput, RegisteredBanksInput, RegisteredBanksOutput } from './input-output-parm';
import { BankDashboardService } from './bank-dashboard.service';
// import { LoaderService } from '../../shared/loader/loader.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { Subscription } from '../../../../node_modules/rxjs';

@Component({
  selector: 'app-bank-dashboard',
  templateUrl: './bank-dashboard.component.html',
  styleUrls: ['./bank-dashboard.component.css']
})
export class BankDashboardComponent implements OnInit {
  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;

  isPITxsnUpdate: boolean = false;
  isPMTxsnUpdate: boolean = false;
  isPISuccessUpdate: boolean = false;
  isPMSuccessUpdate: boolean = false;
  isTopBankUpdate: boolean = false;
  isTopInstrumentUpdate: boolean = false;
  isRegisteredBanksUpdate: boolean

  isGraphUpdate: boolean = false;
  isRegisteredBanksAvail: boolean = false;
  isTopBankAvail: boolean = false;
  isTopInstrumentAvail: boolean = false;

  textHeading: string;

  PInstituteAmountData: Array<any>;
  PInstituteAmountLabels: Array<any>;

  public PInstAmountLabels: Array<any>;
  public PInstAmountData: Array<any>;

  public lineSFChartData: Array<any>;
  public lineSFChartLabels: Array<any>;

  public linePISFChartData: Array<any>;
  public linePISFChartLabels: Array<any>;

  viewBankDashboard: ViewBankDashboard;
  paymentTxnsAmountInputForBoth: PaymentTxnsAmountInputForBoth;
  paymentTxnsAmountOutputForBoth: PaymentTxnsAmountOutputForBoth;
  paymentSuccessFailureOutputForBoth: PaymentSuccessFailureOutputForBoth;
  topRecordsInput: TopRecordsInput;
  topRecordsOutputForBank: TopRecordsOutput;
  topRecordsOutputForInst: TopRecordsOutput;
  registeredBanksInput: RegisteredBanksInput;
  registeredBanksOutput: RegisteredBanksOutput;
  subscription:Subscription;
  lang:string;

  customFlag: boolean = false;
  customFlagHide: boolean = false;

  from_Date: string;
  to_Date: string;
  finalToDate: Date;

  finalMinDate:Date;
  maxDate: Date;
  ture: any;

  constructor(private dataStorageService: DataStorageService,
    private bankService: BankDashboardService,
    private logger: NGXLogger,
    private router: Router,
    private leftMenu: LeftMenu,
    private pipe: DatePipe,
    // private loaderService: LoaderService,
    private readonly translate: TranslateService

  ) { }

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    window.scroll(0, 0);
    this.viewBankDashboard = new ViewBankDashboard();
    this.paymentTxnsAmountInputForBoth = new PaymentTxnsAmountInputForBoth();
    this.paymentTxnsAmountOutputForBoth = new PaymentTxnsAmountOutputForBoth();
    this.paymentSuccessFailureOutputForBoth = new PaymentSuccessFailureOutputForBoth();
    this.topRecordsInput = new TopRecordsInput();
    this.topRecordsOutputForBank = new TopRecordsOutput();
    this.topRecordsOutputForInst = new TopRecordsOutput();
    this.registeredBanksInput = new RegisteredBanksInput();
    this.registeredBanksOutput = new RegisteredBanksOutput();

    this.viewBankDashboard.mode = "web";
    this.getTodayWeekMonthYearDate('today');
    this.leftMenu = new LeftMenu();
    this.leftMenu.dashboard = true;
  }

  onCustom(){
    this.customFlagHide = true;
    this.customFlag = true;
    this.activeAllFlag = false;
    this.activeYearFlag = false;
    this.activeMonthFlag = false;
    this.activeWeekFlag = false;
    this.activeTodayFlag = false;
  }

  getDashboardDataOfADateRange(objDate1, objDate2) {
    //console.log("range data fatch");
    //this.logger.debug("custom dashboard...");
    let mm1 = new Date(objDate1).getMonth() + 1;
    let mm2 = new Date(objDate2).getMonth() + 1;
    let rStartDate = new Date(objDate1).getFullYear() + "-" + mm1 + "-" + new Date(objDate1).getDate();
    //console.log(rStartDate);
    let rangeStartDate = this.pipe.transform(rStartDate, 'yyyy-MM-dd');
    let rLastDate = new Date(objDate2).getFullYear() + "-" + mm2 + "-" + new Date(objDate2).getDate();
    let rangeLastDate = this.pipe.transform(rLastDate, 'yyyy-MM-dd');

    this.viewBankDashboard.datafor = "custom";
    this.viewBankDashboard.startdate = rangeStartDate;
    this.viewBankDashboard.enddate = rangeLastDate;
    this.textHeading = "Custom's ";

    this.customFlagHide = false;

    this.getBankPaymentTxnsAmountForPI();
    this.getBankPaymentTxnsAmountForPM();
    this.getBankPaymentSuccessFailureForPI();
    this.getBankPaymentSuccessFailureForPM();
    this.getTop3BanksRecords();
    this.getTop3PaymentInstrumentRecords();
    this.getRegisteredBanks();
  }

  getTodayWeekMonthYearDate(valTime) {
    let todayFrmtdDate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    // -----------------------week start n end date--------------
    let first1 = new Date().getDate() - new Date().getDay();
    let last1 = first1 + 6;
    let ws = new Date(new Date().setDate(first1));
    let weekStartDate = this.pipe.transform(ws, 'yyyy-MM-dd');
    let wl = new Date(new Date().setDate(last1));
    let weekLastDate = this.pipe.transform(wl, 'yyyy-MM-dd');
    // -----------------------month and start n end date--------------
    let monStrt = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    let monthStartDate = this.pipe.transform(monStrt, 'yyyy-MM-dd');
    let monEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    let monthLastDate = this.pipe.transform(monEnd, 'yyyy-MM-dd');
    let yStrt = new Date(new Date().getFullYear(), 0, 1);
    let yearStartDate = this.pipe.transform(yStrt, 'yyyy-MM-dd');
    let yEnd = new Date(new Date().getFullYear(), 11, 31);
    let yearEndDate = this.pipe.transform(yEnd, 'yyyy-MM-dd');

    if (valTime == 'all') {
      this.activeAllFlag = true;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBankDashboard.datafor = "all";
      this.viewBankDashboard.startdate = yearStartDate;
      this.viewBankDashboard.enddate = todayFrmtdDate;
      this.textHeading = "All";
    }
    else if (valTime == 'year') {
      this.activeAllFlag = false;
      this.activeYearFlag = true;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBankDashboard.datafor = "year";
      this.viewBankDashboard.startdate = yearStartDate;
      this.viewBankDashboard.enddate = yearEndDate;
      this.textHeading = "This year's";
    }
    else if (valTime == 'month') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = true;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBankDashboard.datafor = "month";
      this.viewBankDashboard.startdate = monthStartDate;
      this.viewBankDashboard.enddate = monthLastDate;
      this.textHeading = "This month's";
    }
    else if (valTime == 'week') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = true;
      this.activeTodayFlag = false;
      this.viewBankDashboard.datafor = "week";
      this.viewBankDashboard.startdate = weekStartDate;
      this.viewBankDashboard.enddate = weekLastDate;
      this.textHeading = "This week's";
    }
    else if (valTime == 'today') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = true;
      this.viewBankDashboard.datafor = "today";
      this.viewBankDashboard.startdate = todayFrmtdDate;
      this.textHeading = "Today's";
    }

    this.customFlagHide = false;
    this.getBankPaymentTxnsAmountForPI();
    this.getBankPaymentTxnsAmountForPM();
    this.getBankPaymentSuccessFailureForPI();
    this.getBankPaymentSuccessFailureForPM();
    this.getTop3BanksRecords();
    this.getTop3PaymentInstrumentRecords();
    this.getRegisteredBanks();
  }
  // ------------------------------Payment Institute-Transction Amount---------------------------------
  public PInstituteAmountType: string = 'bar';
  public PInstituteAmountLegend: boolean = true;
  public PInstituteAmountOptions: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90
          }
        }],
        yAxes:
          [{
            ticks: { min: 0, beginAtZero: true, fontSize: 13 },
            scaleLabel: { display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: 'rgba(233,31,99,1)' }
          }]
      }
  };
  //this.PInstituteAmountData  =
  //   [
  //     { data: ['40000', '57500', '41000', '60000', '52500', '28200', '50000', '52000', '40000', '22000', '39000', '21000'], label: 'Transaction Amount', }
  //   ]
  // this.PInstituteAmountLabels = ['EBL', 'DBBL', 'CITY BANK', 'BRACK BANK', 'BKASH', 'ROCKET', 'BANK ASIA', 'IBBL', 'PAYZA', 'DMONEY', 'IPAY', 'Q-CASH']
  getBankPaymentTxnsAmountForPI() {
    this.isPITxsnUpdate = false;
    this.paymentTxnsAmountInputForBoth.type = "pi";
    this.paymentTxnsAmountInputForBoth.datafor = this.viewBankDashboard.datafor;
    this.paymentTxnsAmountInputForBoth.mode = this.viewBankDashboard.mode;
    this.paymentTxnsAmountInputForBoth.startdate = this.viewBankDashboard.startdate;
    this.paymentTxnsAmountInputForBoth.enddate = this.viewBankDashboard.enddate;
    //this.logger.debug("request"+JSON.stringify(this.paymentTxnsAmountInputForBoth));
    this.bankService.getBankPaymentTxnsAmountForBoth(this.paymentTxnsAmountInputForBoth).subscribe((data) => {
      //this.logger.debug("data for txsn amount........ " + JSON.stringify(data.body));
      this.isPITxsnUpdate = true;
      this.paymentTxnsAmountOutputForBoth = data.body as PaymentTxnsAmountOutputForBoth;
      this.PInstituteAmountData = [
        { data: this.paymentTxnsAmountOutputForBoth.total_amount, label: 'Transaction Amount' }
      ];
      this.PInstituteAmountLabels = this.paymentTxnsAmountOutputForBoth.payment_name;

    });

  }
  public PInstituteAmountColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,31,99,0.5)',
      borderColor: 'rgba(233,31,99,1)',
      pointBackgroundColor: 'rgba(233,31,99,0.5)',
      pointBorderColor: 'rgba(233,31,99,1)',
      pointHoverBackgroundColor: 'rgba(233,31,99,0.5)',
      pointHoverBorderColor: 'rgba(233,31,99,1)'
    }
  ];

  public PInstituteAmountClicked(e: any): void {
    //console.log(e);
  }
  public PInstituteAmountHovered(e: any): void {
    //console.log(e);
  }
  // -----------------------------------Payment Instrument-Transction Amount------------------------------------------

  public PInstAmountType: string = 'bar';
  public PInstAmountLegend: boolean = true;
  // this.PInstAmountLabels = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];
  //  this.PInstAmountData = [
  //   {
  //     data: [80000, 88000, 42000, 50000, 58000, 41000, 90000, 50000, 60000, 41000], label: 'Transaction Amount',
  //   }
  // ];
  getBankPaymentTxnsAmountForPM() {
    this.isPMTxsnUpdate = false;
    this.paymentTxnsAmountInputForBoth.type = "pm";
    this.paymentTxnsAmountInputForBoth.datafor = this.viewBankDashboard.datafor;
    this.paymentTxnsAmountInputForBoth.mode = this.viewBankDashboard.mode;
    this.paymentTxnsAmountInputForBoth.startdate = this.viewBankDashboard.startdate;
    this.paymentTxnsAmountInputForBoth.enddate = this.viewBankDashboard.enddate;
    //this.logger.debug("request"+JSON.stringify(this.paymentTxnsAmountInputForBoth));
    this.bankService.getBankPaymentTxnsAmountForBoth(this.paymentTxnsAmountInputForBoth).subscribe((data) => {
      //this.logger.debug("data for txsn amount........ " + JSON.stringify(data.body));
      this.isPMTxsnUpdate = true;
      this.paymentTxnsAmountOutputForBoth = data.body as PaymentTxnsAmountOutputForBoth;
      this.PInstAmountData = [
        { data: this.paymentTxnsAmountOutputForBoth.total_amount, label: 'Transaction Amount' }
      ];
      this.PInstAmountLabels = this.paymentTxnsAmountOutputForBoth.payment_name;

    });
  }
  PInstAmountOptions = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: 'rgba(123,149,231,1)' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public PInstAmountColors: Array<any> = [
    {
      backgroundColor: 'rgba(123,149,231,0.5)',
      borderColor: 'rgba(123,149,231,1)',
      pointBackgroundColor: 'rgba(123,149,231,0.5)',
      pointBorderColor: 'rgba(123,149,231,1)',
      pointHoverBackgroundColor: 'rgba(123,149,231,0.5)',
      pointHoverBorderColor: 'rgba(123,149,231,1)'
    }
  ];
  public PInstAmountClicked(e: any): void {
    //console.log(e);
  }
  public PInstAmountHovered(e: any): void {
    //console.log(e);
  }

  // -----------------------Payment Institute-Success and Failure Rate--------------------------
  // this.lineSFChartData=
  //   [
  //     { data: [10, 10, 5, 4, 1, 7, 8, 2, 6, 8, 6, 4, 9, 5, 4], label: 'Failure' },
  //     { data: [90, 90, 95, 96, 99, 93, 92, 98, 94, 92, 94, 91, 95, 96, 99], label: 'Success' }
  //   ];
  //this.lineSFChartLabels = ['EBL', 'DBBL', 'City Bank', 'BRAC Bank', 'BKash', 'Rocket', 'Bank Asia', 'IBBL', 'PAYZA', 'DMoney', 'IPay', 'QCash', 'RFID', 'SEBL', 'UCBL'];
  public lineSFChartType: string = 'bar';

  getBankPaymentSuccessFailureForPI() {
    this.isPISuccessUpdate = false;
    this.paymentTxnsAmountInputForBoth.type = "pi";
    this.paymentTxnsAmountInputForBoth.datafor = this.viewBankDashboard.datafor;
    this.paymentTxnsAmountInputForBoth.mode = this.viewBankDashboard.mode;
    this.paymentTxnsAmountInputForBoth.startdate = this.viewBankDashboard.startdate;
    this.paymentTxnsAmountInputForBoth.enddate = this.viewBankDashboard.enddate;
    //this.logger.debug("request"+JSON.stringify(this.paymentTxnsAmountInputForBoth));
    this.bankService.getBankPaymentSuccessFailureRateForBoth(this.paymentTxnsAmountInputForBoth).subscribe((data) => {
      this.isPISuccessUpdate = true;
      this.paymentSuccessFailureOutputForBoth = data.body as PaymentSuccessFailureOutputForBoth;
      this.lineSFChartData = [
        {
          data: this.paymentSuccessFailureOutputForBoth.success, label: 'Success'
        },
        {
          data: this.paymentSuccessFailureOutputForBoth.fail, label: 'Failure'
        }

      ]
      this.lineSFChartLabels = this.paymentSuccessFailureOutputForBoth.payment_name;
    });

  }

  public lineSFChartOptions: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#0d9b8c' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public lineSFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: 'rgba(233,30,99,0.5)',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: 'rgba(233,30,99,1)',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: 'rgba(233,30,99,1)',
    },
    {
      backgroundColor: 'rgba(13,155,140,0.4)',
      borderColor: '#0d9b8c',
      pointBackgroundColor: 'rgba(13,155,140,1)',
      pointBorderColor: 'rgba(13,155,140,1)',
      pointHoverBackgroundColor: 'rgba(13,155,140,1)',
      pointHoverBorderColor: 'rgba(13,155,140,1)'
    },
  ];
  // -------------------Payment Instrument-Success and Failure Rate------------------------------

  // this.linePISFChartData =
  //   [
  //     { data: [0, 7, 3, 12, 8, 5, 9, 11, 4, 8], label: 'Failure' },
  //     { data: [100, 93, 97, 88, 92, 95, 91, 89, 96, 92], label: 'Success', fill: false }
  //   ];
  //  this.linePISFChartLabels = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];

  getBankPaymentSuccessFailureForPM() {
    this.isPMSuccessUpdate = false;
    this.paymentTxnsAmountInputForBoth.type = "pm";
    this.paymentTxnsAmountInputForBoth.datafor = this.viewBankDashboard.datafor;
    this.paymentTxnsAmountInputForBoth.mode = this.viewBankDashboard.mode;
    this.paymentTxnsAmountInputForBoth.startdate = this.viewBankDashboard.startdate;
    this.paymentTxnsAmountInputForBoth.enddate = this.viewBankDashboard.enddate;
    //this.logger.debug("request"+JSON.stringify(this.paymentTxnsAmountInputForBoth));
    this.bankService.getBankPaymentSuccessFailureRateForBoth(this.paymentTxnsAmountInputForBoth).subscribe((data) => {
      this.isPMSuccessUpdate = true;
      this.paymentSuccessFailureOutputForBoth = data.body as PaymentSuccessFailureOutputForBoth;
      this.linePISFChartData = [
        {
          data: this.paymentSuccessFailureOutputForBoth.success, label: 'Success'
        },
        {
          data: this.paymentSuccessFailureOutputForBoth.fail, label: 'Failure'
        }
      ]
      this.linePISFChartLabels = this.paymentSuccessFailureOutputForBoth.payment_name;

    });
  }

  public linePISFChartType: string = 'bar';
  public linePISFChartOptions: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#ff9900' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public linePISFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(0,191,165,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,0.5)',
      pointBorderColor: 'rgba(0,191,165,0.5)',
      pointHoverBackgroundColor: 'rgba(0,191,165,0.5)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
    {
      backgroundColor: 'rgba(255,153,0,0.5)',
      borderColor: 'rgba(255,153,0,1)',
      pointBackgroundColor: 'rgba(255,153,0,1)',
      pointBorderColor: 'rgba(255,153,0,1)',
      pointHoverBackgroundColor: 'rgba(255,153,0,1)',
      pointHoverBorderColor: 'rgba(255,153,0,1)'
    },
  ];
  // ------------------------------Top 3 Banks---------------------------------------
  getTop3BanksRecords() {
    this.isTopBankUpdate = false;
    this.isTopBankAvail = false;
    this.topRecordsInput.datafor = this.viewBankDashboard.datafor;
    this.topRecordsInput.startdate = this.viewBankDashboard.startdate;
    this.topRecordsInput.enddate = this.viewBankDashboard.enddate;
    this.topRecordsInput.mode = this.viewBankDashboard.mode;
    this.topRecordsInput.recordfor = "pi";
    //this.logger.debug("request"+JSON.stringify(this.topRecordsInput));
    this.bankService.getTopRecordsView(this.topRecordsInput).subscribe((data) => {
      this.topRecordsOutputForBank = data.body as TopRecordsOutput;
      if (this.topRecordsOutputForBank.top_records.length == 0) {
        this.isTopBankAvail = true;
      }
      this.isTopBankUpdate = true;
    });
  }
  // ------------------------------Top 3 Payment Instruments--------------------------------------
  getTop3PaymentInstrumentRecords() {
    this.isTopInstrumentUpdate = false;
    this.isTopInstrumentAvail = false;
    this.topRecordsInput.datafor = this.viewBankDashboard.datafor;
    this.topRecordsInput.startdate = this.viewBankDashboard.startdate;
    this.topRecordsInput.enddate = this.viewBankDashboard.enddate;
    this.topRecordsInput.mode = this.viewBankDashboard.mode;
    this.topRecordsInput.recordfor = "pm";
    //this.logger.debug("request"+JSON.stringify(this.topRecordsInput));
    this.bankService.getTopRecordsView(this.topRecordsInput).subscribe((data) => {
      this.isTopInstrumentUpdate = true;
      this.topRecordsOutputForInst = data.body as TopRecordsOutput;
      if (this.topRecordsOutputForInst.top_records.length == 0) {
        this.isTopInstrumentAvail = true;
      }
    });
  }
  // ------------------------------Registered Banks---------------------------------------
  getRegisteredBanks() {
    this.isRegisteredBanksUpdate = false;
    this.isRegisteredBanksAvail = false;
    this.registeredBanksInput.datafor = this.viewBankDashboard.datafor;
    this.registeredBanksInput.mode = this.viewBankDashboard.mode;
    this.registeredBanksInput.startdate = this.viewBankDashboard.startdate;
    this.registeredBanksInput.enddate = this.viewBankDashboard.enddate;
    //this.logger.debug("request"+JSON.stringify(this.registeredBanksInput));
    this.bankService.getRegisteredBanks(this.registeredBanksInput).subscribe((data) => {
      this.isRegisteredBanksUpdate = true;
      this.registeredBanksOutput = data.body as RegisteredBanksOutput;
      if (this.registeredBanksOutput.ekpay_registered_banks == null) {
        this.isRegisteredBanksAvail = true;
      }
    });
  }

  limitOfTo() {
    let m;
    let d;
    let y;
    let nM;
    let nD;
    let nY;
    let maxDateForTo;
    m = new Date(this.from_Date).getMonth() + 1;
    d = new Date(this.from_Date).getDate();
    y = new Date(this.from_Date).getFullYear();
    if ((m == 1 || m == 3 || m == 8) && d == 31) {
      nM = m + 3;
      nD = 30;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if ((m == 1 || m == 3 || m == 8) && d != 31) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 2 || m == 4 || m == 9 || m == 5 || m == 6 || m == 7) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 10) {
      nM = 1;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && (d == 30 || d == 29)) {
      nM = 2;
      // nD = 28;
      let year = y + 1;
      let isLeap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0)
            isLeap = true;
          else
            isLeap = false;
        }
        else
          isLeap = true;
      }
      else {
        isLeap = false;
      }

      if (isLeap == true) {
        nD = 29;
      }
      else {
        nD = 28;
      }
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && !(d == 30 || d == 29)) {
      nM = 2;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 12) {
      nM = 3;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/bank-dashboard/bank-dashboard.component.ts